import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Chip } from '@material-ui/core';
import SyncIcon from '@material-ui/icons/Sync';
import MicIcon from '@material-ui/icons/Mic';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  autoSaveText: {
    fontSize: '0.68rem',
    color: '#64748b',
    fontStyle: 'italic',
  },
}));

const NetworkStatusBar = ({
  pendingSyncCount = 0,
  pendingAudioCount = 0,
  lastAutoSave = null,
  isOfflineMode = false,
  isSyncing = false,
  onSyncClick,
}) => {
  const classes = useStyles();

  // const formatAutoSaveTime = (timestamp) => {
  //   if (!timestamp) return '';
  //   const date = new Date(timestamp);
  //   return `Auto-saved ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  // };

  const totalPending = pendingSyncCount + pendingAudioCount;
  if (!totalPending) return null;

  return (
    <Box className={classes.container}>
      {totalPending > 0 && (
        <Chip
          size="medium"
          icon={<SyncIcon className={isSyncing ? 'spin-icon' : ''} style={{ fontSize: 14 }} />}
          label={
            isSyncing
              ? 'Syncing pending offline data...'
              : isOfflineMode
                ? `${totalPending} draft${totalPending !== 1 ? 's' : ''} saved offline — will sync when online`
                : `${totalPending} draft${totalPending !== 1 ? 's' : ''} pending — click to sync now`
          }
          onClick={!isOfflineMode && !isSyncing && onSyncClick ? onSyncClick : undefined}
          style={{
            fontSize: '0.68rem',
            height: 24,
            backgroundColor: isSyncing ? '#e0f2fe' : isOfflineMode ? '#fed7aa' : '#dbeafe',
            color: isSyncing ? '#075985' : isOfflineMode ? '#92400e' : '#1d4ed8',
            cursor: !isOfflineMode && !isSyncing && onSyncClick ? 'pointer' : 'default',
          }}
        />
      )}
      {/* {lastAutoSave && (
        <Typography className={classes.autoSaveText}>
          {formatAutoSaveTime(lastAutoSave)}
        </Typography>
      )} */}
    </Box>
  );
};

export default NetworkStatusBar;
